import styled from '@emotion/styled';
import { Container } from '@mui/material';
import { theme } from '../../lib/index';

export const Wrapper = styled(Container, {})({
  height: '100vh',

  [theme.breakpoints.up('laptop')]: {
    height: 'calc(100vh - 238px)', // 238px = filters-height + margins/paddings
  },
  textAlign: 'center',

  '& .MuiTypography-h2': {
    margin: 10,

    fontSize: 20,

    [theme.breakpoints.up('laptop')]: {
      margin: 30,
    },
  },

  '& .MuiTypography-body1': {
    padding: '0 10px',

    [theme.breakpoints.up('laptop')]: {
      padding: '0 200px',
    },
  },

  '& .MuiButton-root': {
    margin: 30,
    padding: '10px 20px',
    borderColor: theme.palette.white,

    background: theme.palette.black,

    color: theme.palette.newSecondary,

    '&:hover': {
      background: theme.palette.darkgrey,
    },
  },
});
